import { getCookie, setCookie } from "./Common";
import { Permission } from "../types/ai";
import { getMyPermissions } from "../services/AiService";

/** Permissions of the logged-in user, as returned at login and stored in the session cookie. */
export const myPermissions = (): Permission[] => {
  const cookie: any = getCookie("data");
  return (cookie?.permissions as Permission[]) || [];
};

export const hasPermission = (p: Permission): boolean => myPermissions().includes(p);

export const hasAnyPermission = (...ps: Permission[]): boolean => ps.some((p) => myPermissions().includes(p));

export const currentRole = (): string | null => {
  const cookie: any = getCookie("data");
  return cookie?.role || null;
};

export const currentUserId = (): number | null => {
  const cookie: any = getCookie("data");
  return cookie?.id ?? null;
};

/** Sessions created before QualiCheck AI have no permissions in the cookie; refresh them once from the API. */
export const refreshPermissions = async (): Promise<void> => {
  const cookie: any = getCookie("data");
  if (!cookie?.token) return;
  try {
    const permissions = await getMyPermissions();
    setCookie({ ...cookie, permissions });
  } catch {
    // Platform operators (SUPER_ADMIN) and expired sessions simply keep what they have.
  }
};
